import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import {
  AUTH_PROVIDERS,
  POST_AUTH_ACTION_KEY,
  authStartUrl,
  type PostAuthAction,
} from '../auth/providers'

interface SignInModalProps {
  open: boolean
  intendedAction: PostAuthAction | null
  onClose: () => void
}

export function SignInModal({
  open,
  intendedAction,
  onClose,
}: SignInModalProps) {
  const { t } = useTranslation()

  if (!open) return null

  function startSignIn(providerIndex: number) {
    const provider = AUTH_PROVIDERS[providerIndex]
    if (!provider) return
    const url = authStartUrl(provider)
    if (!url) return
    try {
      if (intendedAction) {
        window.sessionStorage.setItem(POST_AUTH_ACTION_KEY, intendedAction)
      } else {
        window.sessionStorage.removeItem(POST_AUTH_ACTION_KEY)
      }
    } catch {
      // OAuth still works if session storage is unavailable.
    }
    window.location.assign(url)
  }

  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <section
        className="modal sign-in-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sign-in-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="auth-kicker">{t('auth.kicker')}</div>
        <h2 id="sign-in-title">{t('auth.title')}</h2>
        <p className="auth-intro">{t('auth.explanation')}</p>
        <div className="auth-providers">
          {AUTH_PROVIDERS.map((provider, index) => (
            <button
              key={provider.id}
              type="button"
              className={`auth-provider auth-provider-${provider.id}`}
              disabled={!provider.enabled}
              onClick={() => startSignIn(index)}
            >
              <span>{t(`auth.providers.${provider.id}`)}</span>
              {!provider.enabled && <small>{t('auth.comingLater')}</small>}
            </button>
          ))}
        </div>
        <p className="auth-legal">
          {t('auth.dataUse')}{' '}
          <Link to="/privacy" onClick={onClose}>
            {t('auth.privacyLink')}
          </Link>{' '}
          .
        </p>
        <div className="form-actions">
          <button type="button" className="btn" onClick={onClose}>
            {t('actions.cancel')}
          </button>
        </div>
      </section>
    </div>
  )
}
